import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigurationSettings } from "src/app/models/configuration.settings";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class FileuploadService {
  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
  };
  constructor(
    private http: HttpClient,
    private configurationSettings: ConfigurationSettings
  ) {}

  uploadFiletoServer(fileToUpload: File, botConfigId: number): Observable<any> {
    const formData = new FormData();
    formData.append("file", fileToUpload, fileToUpload.name);
    return this.http.post(
      this.configurationSettings.userfileUpload_api_endpoint +
        "/PostUserUploadedFiles?botConfigId=" +
        botConfigId,
      formData
    );
  }

  GetAllUploadedFiles(botConfigId: number): Observable<any> {
    return this.http.get(
      this.configurationSettings.userfileUpload_api_endpoint +
        "/GetUploadedFiles?botConfigId=" +
        botConfigId
    );
  }
  DeleteFile(fileName: string): Observable<any> {
   return this.http.post(
      this.configurationSettings.userfileUpload_api_endpoint +
     "/DeleteUploadedFile?fileName=" + fileName,
        fileName
    );
  }
}
